import React from 'react'

import { connect } from "react-redux"

import LobbyistTable from '../components/lobbyist/lobbyist-table'

import { Accordion, AccordionTab } from 'primereact/accordion'

import * as lookupCodeActionCreators from "../actionCreators/lookupCode"
import * as lobbyistActionCreators from "../actionCreators/lobbyist"
import * as appActionCreators from "../actionCreators/app"
import * as systemParameterActionCreators from "../actionCreators/systemParameter"

import { ROLE_ADMIN, STATUS_APPROVED, STATUS_SURRENDERED, STATUS_REJECTED } from '../js/const'
import { downloadFile } from '../js/file'

import '../css/home.css'

class Home extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // store filter values in state so we can pick up changes
      activeLobbyistStatusFilter: null,
      activeLobbyistSort: { sortField: 'TradingName', sortOrder: 1 },
      inactiveLobbyistSort: { sortField: 'TradingName', sortOrder: 0 },
      rejectedLobbyistSort: { sortField: 'TradingName', sortOrder: 0 }
    }

    // create references to table so we can acces filtering method
    this.activeLobbyistTable = React.createRef()
    this.inactiveLobbyistTable = React.createRef()
    this.rejectedLobbyistTable = React.createRef()
  }

  componentDidMount() {
    let isAdmin = this.props.auth.roles && this.props.auth.roles.some(role => role === ROLE_ADMIN)
    //is invoked immediately after a component is mounted. 
    //Initialization that requires DOM nodes should go here. If you need to load data from a remote endpoint, this is a good place to instantiate the network request.   
    this.props.setLoading(true)
      .then(() => {
        // store the promises in an array so we can kick off loading at the same time but it won't continue until all the loading has finished
        let dataloadPromises = []
        if (isAdmin) {
          dataloadPromises.push(this.props.getLobbyistStatuses())
        }

        dataloadPromises.push(this.props.getHomePageText())
        dataloadPromises.push(this.props.getLobbyists())
        return Promise.all(dataloadPromises)
      })
      .then(() => this.props.setLoading(false))
      .catch((error) => {
        this.props.handleError(error)
          .then(() => this.props.setLoading(false))
      })
  }

  // use routing to go to lobbyist page
  goToLobbyist = e => {
    this.props.history.push('/lobbyist/' + e.data.LobbyistId)
  }

  // update filter in state
  updateStatusFilter = (e, tableRef, statusFilterName) => {
    let status = e.value ? e.value.Description : ''
    tableRef.current.filter(status, 'StatusDescription', 'equals')
    this.setState({ [statusFilterName]: e.value })
  }

  updateSortField = (e, sortFieldName) => {
    this.setState({ [sortFieldName]: { sortField: e.sortField, sortOrder: e.sortOrder } })
  }

  accordionTabOpened = e => this.props.addActiveLobbyistGridIndex(e.index)
  accordionTabClosed = e => this.props.removeActiveLobbyistGridIndex(e.index)

  exportLobbyistsToExcel = tableRef => {
    // use DataTable reference to call the function that applies filtering and sorting to get the same lobbyists that are displayed in the grid
    // NOTE: this isn't a documented method so it could potentially change
    let processedLobbyists = tableRef.current.processData()
    let lobbyistIds = processedLobbyists.map(lobbyist => lobbyist.LobbyistId)
    this.exportToExcel(this.props.exportLobbyistsToExcel, lobbyistIds)
  }

  exportToExcel = (exportAction, data) => {
    // show loading icon since we are doing an ajax call
    this.props.setLoading(true)
      .then(() => exportAction(data))
      .then((response) => {
        var fileData = new Blob([response.data])

        // get filename from the content disposition header that is set server side
        let contentDisposition = response.headers['content-disposition']
        let filename = contentDisposition.substring(contentDisposition.indexOf('=') + 1)
        downloadFile(fileData, filename)

        this.props.setLoading(false)
      })
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }

  renderAccordionLobbyistTableTab = ({ header, lobbyists, isAdmin, sort, statusFilter, tableRef, statuses }) => {
    let key = header.replace(' ', '')
    return (
      <AccordionTab key={key} header={header}>
        <LobbyistTable lobbyists={lobbyists} isAdmin={isAdmin} statusFilter={statusFilter} goToLobbyist={this.goToLobbyist} tableRef={tableRef}
          exportToExcel={this.exportLobbyistsToExcel} statuses={statuses} sort={sort} />
      </AccordionTab>
    )
  }

  render() {
    let isAdmin = this.props.auth.roles && this.props.auth.roles.some(role => role === ROLE_ADMIN)
    let activeLobbyists = isAdmin ? this.props.lobbyist.lobbyists.filter(lobbyist => lobbyist.StatusCode !== STATUS_SURRENDERED && lobbyist.StatusCode !== STATUS_REJECTED) : this.props.lobbyist.lobbyists.filter(lobbyist => lobbyist.StatusCode === STATUS_APPROVED)
    let inactiveLobbyists = this.props.lobbyist.lobbyists.filter(lobbyist => lobbyist.StatusCode === STATUS_SURRENDERED)
    let rejectedLobbyists = this.props.lobbyist.lobbyists.filter(lobbyist => lobbyist.StatusCode === STATUS_REJECTED)
    let lobbyistStatuses = this.props.lookupCode.lobbyistStatuses.filter(status => status.SystemCode !== STATUS_SURRENDERED && status.SystemCode !== STATUS_REJECTED)

    let activeLobbyistStatusFilter = {
      filterName: 'activeLobbyistStatusFilter',
      value: this.state.activeLobbyistStatusFilter,
      onChange: this.updateStatusFilter
    }

    let activeLobbyistSort = {
      sortName: 'activeLobbyistSort',
      value: this.state.activeLobbyistSort,
      onChange: this.updateSortField
    }

    let inactiveLobbyistSort = {
      sortName: 'inactiveLobbyistSort',
      value: this.state.inactiveLobbyistSort,
      onChange: this.updateSortField
    }

    let lobbyistTableTabDefinitions = [
      { header: 'Active Lobbyists', lobbyists: activeLobbyists, sort: activeLobbyistSort, statusFilter: activeLobbyistStatusFilter, tableRef: this.activeLobbyistTable },
      { header: 'Inactive Lobbyists', lobbyists: inactiveLobbyists, sort: inactiveLobbyistSort, tableRef: this.inactiveLobbyistTable }
    ]

    if (isAdmin) {
      let rejectedLobbyistSort = {
        sortName: 'rejectedLobbyistSort',
        value: this.state.rejectedLobbyistSort,
        onChange: this.updateSortField
      }
        lobbyistTableTabDefinitions.push({ header: 'Refused/ Cancelled Lobbyist', lobbyists: rejectedLobbyists, sort: rejectedLobbyistSort, tableRef: this.rejectedLobbyistTable })
    }

    let lobbyistTableTabs = lobbyistTableTabDefinitions.map(tab => {
      return this.renderAccordionLobbyistTableTab({ ...tab, isAdmin, statuses: lobbyistStatuses })
    })

    return (
      <React.Fragment>
        <div className={"home-page-text"} dangerouslySetInnerHTML={{ __html: this.props.systemParameter.homePageText }} />
        <Accordion multiple={true} activeIndex={this.props.lobbyist.activeGridIndexes} onTabOpen={this.accordionTabOpened} onTabClose={this.accordionTabClosed}>
          {lobbyistTableTabs}
        </Accordion>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  let { lobbyist, auth, lookupCode, systemParameter } = state
  return { lobbyist, auth, lookupCode, systemParameter }
}

// this is how to combine actions available
const actionCreators = {
  ...lobbyistActionCreators,
  ...appActionCreators,
  ...lookupCodeActionCreators,
  ...systemParameterActionCreators
}

export default connect(mapStateToProps, actionCreators)(Home);


// WEBPACK FOOTER //
// ./src/container/Home.js